import { types as actionTypes } from './resultsActions';
import { ActionWithPayload } from '../../../types';
import { WaiverWorkItemsListType } from '../../../../types/waiverWorkItem';

export type WaiverWorkItemSearchResultsState = {
  [key in WaiverWorkItemsListType]: number[];
};

const initialState: WaiverWorkItemSearchResultsState = {
  ACTIVE_WORK_ITEMS: [],
  HISTORICAL_WORK_ITEMS: [],
};

export default function reducer(
  state: WaiverWorkItemSearchResultsState = initialState,
  action: ActionWithPayload<WaiverWorkItemsListType, number[]>,
): WaiverWorkItemSearchResultsState {
  if (!action.payload) {
    return state;
  }

  switch (action.type) {
    case actionTypes.LOAD:
      return {
        ...state,
        [action.payload]: [],
      };
    case actionTypes.LOAD_SUCCESS:
      if (action.response) {
        return {
          ...state,
          [action.payload]: action.response,
        };
      }
      return state;
    default:
      return state;
  }
}
